<form #thisForm="ngForm" (ngSubmit)="submit()">
  <app-dados-boleta
    titulo="Dados da Boleta - Cota"
    [operationDate]="model.operationDate"
    [id]="model.id"
    [accountManagerName]="model.accountManagerName"
    [accountManagerDocument]="model.accountManagerDocument"
    [statusDescription]="model.statusDescription"
  >
  </app-dados-boleta>

  <div class="row">
    <div class="col-md-6 col-12">
      <div class="card mt-3">
        <div class="card-header text-uppercase">Tipo de Liquidação</div>
        <div class="card-body">
          <div class="col-12">
            <div>
              <div
                class="form-check form-check-inline"
                *ngFor="let item of ListSettlementTypes; index as i"
              >
                <input
                  class="form-check-input"
                  data-cy="settlementTypeId"
                  type="radio"
                  name="settlementTypeId"
                  id="{{ 'tm-' + i + '-id' }}"
                  [value]="item.id"
                  [(ngModel)]="model.settlementTypeId"
                  (change)="getSovereign()"
                />
                <label class="form-check-label" for="{{ 'tm-' + i + '-id' }}">
                  {{ item.name }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-12">
      <div class="card mt-3">
        <div class="card-header text-uppercase">Tipo de Operação</div>
        <div class="card-body">
          <div class="col-12">
            <div *ngIf="isCETIP() || isTED()">
              <div
                class="form-check form-check-inline"
                *ngFor="let item of ListOperationTypesQuotas; index as i"
              >
                <input
                  class="form-check-input"
                  data-cy="operationTypeId"
                  type="radio"
                  name="operationTypeId"
                  id="{{ 'operationType-' + i + '-id' }}"
                  [value]="item.id"
                  [(ngModel)]="model.operationTypeId"
                  (change)="fillInvestedFundSelected()"
                />

                <label
                  class="form-check-label"
                  for="{{ 'operationType-' + i + '-id' }}"
                >
                  {{ item.name }}
                </label>
              </div>
            </div>

            <div *ngIf="model.settlementTypeId === 7">
              <div
                class="form-check form-check-inline"
                *ngFor="
                  let item of ListQuotaNoFinancialOperationTypes;
                  index as i
                "
              >
                <input
                  class="form-check-input"
                  data-cy="operationTypeId"
                  type="radio"
                  name="operationTypeId"
                  id="{{ 'operationType-' + i + '-id' }}"
                  [value]="item.id"
                  [(ngModel)]="model.operationTypeId"
                  [required]="model.settlementTypeId === 7"
                />
                <label
                  class="form-check-label"
                  for="{{ 'operationType-' + i + '-id' }}"
                >
                  {{ item.name }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-dados-fundo
    #portfolio
    [canEdit]="canEdit()"
    [canValidate]="canValidate"
    [ticketType]="TicketTypeEnum.Quota"
    [settlementType]="model.settlementTypeId"
    [operationType]="model.operationTypeId"
    (emitterStockSelectedItem)="getStockSelectedFund($event)"
  >
  </app-dados-fundo>

  <div class="card mt-3">
    <div class="card-header text-uppercase">Dados da Operação</div>
    <div class="card-body">
      <div class="row mb-2">
        <div class="col" *ngIf="isNoFinancial()">
          <label for="subscriptionDate">Data de Subscrição </label>
          <div class="form-check form-check-inline">
            <input
              type="text"
              class="form-control"
              data-cy="subscriptionDate"
              name="subscriptionDate"
              [(ngModel)]="model.subscriptionDate"
              [textMask]="{ mask: validator.dateMask, guide: false }"
              [required]="isNoFinancial()"
            />
          </div>
        </div>

        <div class="col-3 mb-3" *ngIf="!isNoFinancial()">
          <div class="form-check form-check-inline">
            <label class="form-check-label" for="isSecondaryMarket">
              Mercado Secundário</label
            >
            <input
              class="form-check-input"
              data-cy="isSecondaryMarket"
              id="isSecondaryMarket"
              name="isSecondaryMarket"
              [(ngModel)]="model.isSecondaryMarket"
              (change)="setSettlementDateBySecondaryMarket()"
              type="checkbox"
            />
            <fa-icon
              *ngIf="(isCETIP() || isTED()) && model.isSecondaryMarket"
              [icon]="faInfoCircle"
              title="Se você negociou este ativo no mercado secundário, é necessário anexar, comprovante de compra e venda, nota de recolhimento e qualquer outro documento que comprove idoneidade"
            ></fa-icon>
          </div>
        </div>

        <div class="col-3 mb-3" *ngIf="isCETIP() || isTED()">
          <div class="form-check form-check-inline">
            <label class="form-check-label" for="isIssueUnitPrice">
              É PU de Emissão</label
            >
            <input
              class="form-check-input"
              data-cy="isIssueUnitPrice"
              id="isIssueUnitPrice"
              name="isIssueUnitPrice"
              [(ngModel)]="model.isIssueUnitPrice"
              type="checkbox"
            />
          </div>
        </div>
        <app-out-custody></app-out-custody>
      </div>

      <div class="row mb-2">
        <div
          *ngIf="
            isCETIP() &&
            (model.operationTypeId != OperationTypeQuota.FullRedemption ||
              model.statusId == WorkFlowStatusEnum.WaitingPassiveApproval)
          "
          class="col-4"
          [class.has-error]="hasError('operationValue')"
        >
          <label
            >Valor da Operação
            <fa-icon
              *ngIf="isFullRedemption()"
              [icon]="faInfoCircle"
              title="Os valores de resgate poderão sofrer alterações por conta do calculo da cota do fundo."
            ></fa-icon
          ></label>
          <label
            *ngIf="
              model.operationTypeId == OperationTypeQuota.FullRedemption &&
              model.statusId != WorkFlowStatusEnum.PendingAdmApproval &&
              model.statusId != WorkFlowStatusEnum.CancelledByAdm &&
              model.statusId != WorkFlowStatusEnum.WaitingPassiveApproval &&
              model.statusId != WorkFlowStatusEnum.CancelledByPassive &&
              model.statusId != null
            "
            >Valor a Liquidar Resgate Total
            <fa-icon
              [icon]="faInfoCircle"
              title="Este foi o valor definido pela Controladoria"
            ></fa-icon
          ></label>
          <input
            type="text"
            data-cy="operationValue"
            class="form-control"
            name="operationValue"
            [(ngModel)]="model.operationValue"
            [textMask]="{ mask: validator.operationValueMask }"
            [required]="isOperationValueRequired()"
            (keyup)="checkQuotaAndAmountValues()"
            [class.ng-invalid]="hasError('operationValue')"
          />
        </div>

        <div
          *ngIf="
            isTED() &&
            (model.operationTypeId != OperationTypeQuota.FullRedemption ||
              model.statusId == WorkFlowStatusEnum.WaitingPassiveApproval)
          "
          class="col-4"
          [class.has-error]="hasError('operationValueTED')"
        >
          <label
            >Valor da Operação
            <fa-icon
              *ngIf="isFullRedemption()"
              [icon]="faInfoCircle"
              title="Os valores de resgate poderão sofrer alterações por conta do calculo da cota do fundo."
            ></fa-icon
          ></label>
          <input
            type="text"
            data-cy="operationValue"
            class="form-control"
            name="operationValue"
            [(ngModel)]="model.operationValue"
            [required]="isOperationValueRequired()"
            (keyup)="checkQuotaAndAmountValues()"
            [class.ng-invalid]="hasError('operationValue')"
            currencyMask
          />
        </div>

        <div
          *ngIf="
            isTED() &&
            model.operationTypeId == OperationTypeQuota.FullRedemption &&
            model.statusId != WorkFlowStatusEnum.PendingAdmApproval &&
            model.statusId != WorkFlowStatusEnum.CancelledByAdm &&
            model.statusId != WorkFlowStatusEnum.WaitingPassiveApproval &&
            model.statusId != WorkFlowStatusEnum.CancelledByPassive &&
            model.statusId != null
          "
          class="col-4"
          [class.has-error]="hasError('operationValueTED')"
        >
          <label
            >Valor a Liquidar Resgate Total
            <fa-icon
              [icon]="faInfoCircle"
              title="Este foi o valor definido pela Controladoria"
            ></fa-icon
          ></label>
          <input
            type="text"
            data-cy="operationValue"
            class="form-control"
            name="operationValue"
            [(ngModel)]="model.operationValue"
            [required]="isOperationValueRequired()"
            (keyup)="checkQuotaAndAmountValues()"
            [class.ng-invalid]="hasError('operationValue')"
            currencyMask
          />
        </div>

        <!-- TODO: Aguardando definição Liquidação Clearing: Colocar (ngModelChange)="calculateOperationValue()" -->
        <div
          class="col-4"
          [class.has-error]="hasError('amount')"
          *ngIf="!isFullRedemption()"
        >
          <label>Quantidade</label>
          <input
            type="number"
            data-cy="amount"
            class="form-control"
            name="amount"
            [(ngModel)]="model.amount"
            [required]="isAmountRequired()"
            (keyup)="calculateQuotaValue()"
            [class.ng-invalid]="hasError('amount')"
          />
        </div>

        <!-- TODO: Aguardando definição Liquidação Clearing -->
        <!-- <div
          *ngIf="
            model.statusId ==
              WorkFlowStatusEnum.WaitingSettlementExternalClearing ||
            model.statusId == WorkFlowStatusEnum.InSettlementExternalClearing ||
            model.statusId == WorkFlowStatusEnum.CancelledByAdm ||
            model.statusId == WorkFlowStatusEnum.Settled ||
            model.statusId == WorkFlowStatusEnum.CancelledBySettlement
          "
          class="col-4"
          [class.has-error]="hasError('command')"
        >
          <label>Comando</label>
          <input
            type="number"
            data-cy="command"
            class="form-control"
            name="command"
            [(ngModel)]="model.command"
            [disabled]="commandIsDisabled"
          />
        </div> -->

        <div
          class="col-4"
          *ngIf="(isCETIP() || isTED()) && model.isSecondaryMarket"
        >
          <label>Valor da Cota</label>
          <input
            [required]="model.isSecondaryMarket"
            type="text"
            data-cy="quotaValue"
            class="form-control"
            name="quotaValue"
            [(ngModel)]="model.quotaValue"
            (keyup)="calculateAmountValue()"
            [class.ng-invalid]="hasError('quotaValue')"
            currencyMask
            [options]="{ precision: '8' }"
          />
        </div>

        <!-- TODO: Aguardando definição Liquidação Clearing -->
        <!-- <div
          *ngIf="isNoFinancial() || isCETIP()"
          class="col-4"
          [class.has-error]="hasError('unitPrice')"
        >
          <label>PU (Preço Unitário)</label>
          <input
            type="text"
            class="form-control"
            data-cy="unitPrice"
            name="unitPrice"
            [(ngModel)]="model.unitPrice"
            [required]="isNoFinancial() || isCETIP()"
            maxlength="35"
            [textMask]="{ mask: validator.unitPriceMask }"
            (ngModelChange)="calculateOperationValue()"
          />
        </div> -->
      </div>
    </div>
  </div>

  <div class="card mt-3">
    <div class="card-header text-uppercase">Dados do Fundo Investido</div>
    <div class="card-body">
      <div class="row mb-2">
        <div class="col-3" *ngIf="isCETIP() || isTED()">
          <div>
            <div class="form-check form-check-inline">
              <label for="isNewFund">Novo fundo</label>
              <input
                class="form-check-input"
                data-cy="isNewFund"
                id="isNewFund"
                name="isNewFund"
                [(ngModel)]="model.isNewFund"
                (change)="cleanInvestedFunds()"
                [disabled]="newFundIsDisabled"
                type="checkbox"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-2">
        <div
          *ngIf="model.isNewFund === false"
          class="col-4"
          [class.has-error]="hasError('fundDocument')"
        >
          <label>CNPJ do Fundo Investido</label>
          <ng-select
            notFoundText="Fundo investido não encontrado"
            typeToSearchText="Digite o CNPJ do fundo investido para pesquisar..."
            [selectOnTab]="true"
            [(ngModel)]="selectedInvestedFund"
            [ngModelOptions]="{ standalone: true }"
            [typeahead]="investedFundSearchDocumentTerm"
            [items]="investedFundsByDocument | async"
            [clearable]="false"
            bindLabel="document"
            [disabled]="investedFundDocumentIsDisabled"
            (change)="fillInvestedFundSelected()"
          >
            <ng-template ng-label-tmp let-item="item">
              {{ item.document }}
            </ng-template>

            <ng-template ng-option-tmp let-item="item">
              {{ item.document }} {{ item.name }}
            </ng-template>
          </ng-select>
        </div>
        <div
          *ngIf="model.isNewFund"
          class="col-4"
          [class.has-error]="hasError('fundDocument')"
        >
          <label>CNPJ do Fundo Investido</label>
          <input
            data-cy="fundDocument"
            type="text"
            class="form-control"
            name="fundDocument"
            [(ngModel)]="model.fundDocument"
            [textMask]="{
              mask: validator.documentLegalPersonMask,
              guide: false
            }"
            pattern="\d{2}[.]\d{3}[.]\d{3}\/\d{4}-\d{2}"
            [disabled]="investedFundDocumentIsDisabled"
          />
        </div>

        <div class="col-8" *ngIf="isTED() && model.isNewFund">
          <div class="row mb-2">
            <div class="col-4">
              <label>Banco</label>
              <app-select-bank
                #fundBankComponent
                name="newFundBank"
                [banks]="banksList"
                [(selectedBankId)]="model.fundBank"
              ></app-select-bank>
            </div>
            <div class="col-4">
              <label>Agência (Sem Dígito)</label>
              <input
                data-cy="newFundBranch"
                type="text"
                class="form-control"
                name="newFundBranch"
                [(ngModel)]="model.fundBranch"
                pattern="\w+-?\w*"
                maxlength="4"
                mask="0000"
              />
            </div>
            <div class="col-4">
              <label>Conta</label>
              <input
                data-cy="newFundAccount"
                type="text"
                class="form-control"
                name="newFundAccount"
                [(ngModel)]="model.fundAccount"
                pattern="\w+-?\w*"
                maxlength="15"
              />
            </div>
          </div>
        </div>

        <div class="col-8" *ngIf="!model.isNewFund && !isCETIP()">
          <label>Dados Bancários</label>
          <ng-select
            notFoundText="Banco, Agência ou Conta Corrente não encontradas"
            typeToSearchText="Digite Banco, Agência ou Conta Corrente"
            [selectOnTab]="true"
            (change)="fillComponentWhenInvestedFundAccountSelected()"
            [(ngModel)]="selectedInvestedFundAccount"
            [ngModelOptions]="{ standalone: true }"
            [items]="investedFundAccountList"
            [clearable]="false"
            [disabled]="investedFundAccountIsDisabled"
          >
            <ng-template
              ng-label-tmp
              let-item="item"
              *ngIf="selectedInvestedFundAccount !== null"
            >
              Banco: {{ item.fundBank }}&nbsp;&nbsp;&nbsp;&nbsp;Agência:
              {{ item.fundBranch }}&nbsp;&nbsp;&nbsp;&nbsp;Conta Corrente:
              {{ item.fundAccount }}
            </ng-template>
            <ng-template ng-header-tmp *ngIf="investedFundAccountList !== null">
              <div class="row mb-2">
                <div class="col-4">Banco</div>
                <div class="col-4">Agência</div>
                <div class="col-4">Conta</div>
              </div>
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              <div class="row mb-2">
                <div class="col-4">{{ item.fundBank }}</div>
                <div class="col-4">{{ item.fundBranch }}</div>
                <div class="col-4">{{ item.fundAccount }}</div>
              </div>
            </ng-template>
          </ng-select>
        </div>
      </div>

      <div class="row mb-2">
        <div
          class="col-6"
          [class.has-error]="hasError('fundName')"
          *ngIf="model.isNewFund === false"
        >
          <label>Nome do Fundo Investido</label>
          <ng-select
            notFoundText="Fundo investido não encontrado"
            typeToSearchText="Digite o nome do fundo investido para pesquisar..."
            [selectOnTab]="true"
            [(ngModel)]="selectedInvestedFund"
            [ngModelOptions]="{ standalone: true }"
            [typeahead]="investedFundSearchNameTerm"
            [items]="investedFundsByName | async"
            [clearable]="false"
            bindLabel="name"
            [disabled]="investedFundNameIsDisabled"
            (change)="fillInvestedFundSelected()"
          >
            <ng-template ng-label-tmp let-item="item">
              {{ item.name }}
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              {{ item.document }} {{ item.name }}
            </ng-template>
          </ng-select>
        </div>

        <!-- TODO: Aguardando definição Liquidação Clearing -->
        <!-- <div class="col-6" *ngIf="isCETIP()">
          <label>Conta Cetip Contraparte</label>
          <input
            type="text"
            data-cy="accountCetipCounterpart"
            class="form-control"
            name="accountCetipCounterpart"
            [(ngModel)]="model.accountCetipCounterpart"
          />
        </div> -->
      </div>

      <div class="row mb-2" *ngIf="model.isNewFund">
        <div class="col-6">
          <label>Nome do Fundo Investido</label>
          <input
            type="text"
            data-cy="fundName"
            class="form-control"
            name="fundName"
            [(ngModel)]="model.fundName"
            maxlength="90"
            required
            pattern="^(?!\s*$).+"
            [disabled]="investedFundDocumentIsDisabled"
          />
        </div>
        <div class="col-6">
          <label for="issuerName"
            >Nome do Administrador do Fundo Investido</label
          >
          <input
            data-cy="issuerName"
            type="text"
            class="form-control"
            id="issuerName"
            name="issuerName"
            [(ngModel)]="model.issuerName"
            maxlength="90"
            required
            pattern="^(?!\s*$).+"
          />
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-6">
          <label>Código do Ativo/IF</label>
          <input
            data-cy="mnemonicCode"
            type="text"
            class="form-control"
            name="mnemonicCode"
            [(ngModel)]="model.mnemonicCode"
            maxlength="20"
            pattern="^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$"
            [required]="isCETIP() || isNoFinancial()"
            [disabled]="mnemonicCodeIsDisabled"
          />
        </div>
        <div class="col-3" [class.has-error]="hasError('quotationDate')">
          <label>Data de Cotização</label>
          <input
            type="text"
            class="form-control"
            data-cy="quotationDate"
            name="quotationDate"
            [(ngModel)]="model.quotationDate"
            [textMask]="{ mask: validator.dateMask, guide: false }"
            [required]="model.isNewFund"
            [readonly]="quotationDateIsDisabled"
          />
        </div>

        <div
          class="col-3"
          [class.has-error]="hasError('settlementDate')"
          [class.has-error]="hasError('isManualsettlementDate')"
        >
          <label
            >Data de Liquidação<fa-icon
              *ngIf="model.isManualSettlementDate"
              [icon]="faInfoCircle"
              title="Este fundo não possuí liquidez e, por isso, a data será preenchida manualmente pelo Administrador Fiduciário,
                   de acordo com o regulamento e a operação será liquidada na data preenchida."
            ></fa-icon
          ></label>
          <input
            type="text"
            class="form-control"
            data-cy="settlementDate"
            name="settlementDate"
            [(ngModel)]="model.settlementDate"
            [disabled]="manualsettlementDateIsDisabled"
            [required]="model.isNewFund || isManualSettlementStep()"
            [textMask]="{ mask: validator.dateMask, guide: false }"
          />
        </div>
      </div>
      <div class="row mb-2">
        <div
          class="col-6"
          [class.has-error]="hasError('fundType')"
          *ngIf="isCETIP() || isTED()"
        >
          <label>Tipo de Cota do Condomínio</label>
          <div>
            <div class="form-check form-check-inline">
              <input
                data-cy="fundTypeClosed"
                disabled
                class="form-check-input"
                type="radio"
                name="fundType"
                [value]="'CFF'"
                id="fundType-3"
                [(ngModel)]="model.fundType"
              />
              <label class="form-check-label" for="fundType-3">
                Cota Fundo Fechado (CFF)
              </label>
            </div>
            <div class="form-check form-check-inline">
              <input
                data-cy="fundTypeOpen"
                disabled
                class="form-check-input"
                type="radio"
                name="fundType"
                [value]="'CFA'"
                id="fundType-4"
                [(ngModel)]="model.fundType"
              />
              <label class="form-check-label" for="fundType-4">
                Cota Fundo Aberto (CFA)
              </label>
            </div>
          </div>
        </div>

        <div
          *ngIf="model.fundSeries == '' && model.fundClass != ''"
          class="col-2"
          [class.has-error]="hasError('fundClass')"
        >
          <label>Classe e Série</label>
          <input
            data-cy="fundClass"
            class="form-control"
            [(value)]="model.fundClass"
            [disabled]="!canEdit()"
          />
        </div>

        <div
          *ngIf="model.fundSeries != ''"
          class="col-2"
          [class.has-error]="hasError('fundClass')"
        >
          <label>Classe</label>
          <mat-select
            data-cy="fundClass"
            class="form-control"
            [(value)]="model.fundClass"
            [disabled]="!canEdit()"
          >
            <mat-option *ngFor="let item of classEnum" [value]="item.name">
              {{ item.name }}
            </mat-option>
          </mat-select>
        </div>

        <div
          *ngIf="model.fundSeries != ''"
          class="col-2"
          [class.has-error]="hasError('fundSeries')"
        >
          <label>Série</label>
          <mat-select
            data-cy="fundSeries"
            class="form-control"
            (selectionChange)="cleanSerieQuantity()"
            [(value)]="model.fundSeries"
            [disabled]="!canEdit()"
          >
            <mat-option *ngFor="let item of serieEnum" [value]="item.name">
              {{ item.name }}
            </mat-option>
          </mat-select>
        </div>

        <div
          *ngIf="hasSerieQuantity() && model.fundSeries != ''"
          [class.has-error]="hasError('fundSeriesQuantity')"
          class="col-2"
        >
          <label
            >Quantidade Série
            <fa-icon
              title="o valor preenchido deve ser maior que 1!"
              [icon]="faInfoCircle"
              *ngIf="this.model.fundSeriesQuantity <= 1"
            ></fa-icon
          ></label>
          <input
            type="number"
            data-cy="fundSeriesQuantity"
            class="form-control"
            name="fundSeriesQuantity"
            [(ngModel)]="model.fundSeriesQuantity"
          />
        </div>
      </div>
    </div>
  </div>
  <br />

  <app-counterpart
    #counterpart
    [ticketType]="TicketTypeEnum.Quota"
    [isSecondaryMarketQuota]="model.isSecondaryMarket"
    [isTedQuota]="isTED()"
    [isCetipQuota]="isCETIP()"
    [isNoFinancialQuota]="isNoFinancial()"
    [canEdit]="canEdit()"
    [canValidate]="canValidate"
    [model]="this.model"
  >
  </app-counterpart>

  <app-fiduci-proof
    #settlementDate
    *ngIf="model.isManualSettlementDate && model.statusDescription != null"
    [ticketId]="model.id"
    [statusDescription]="model.statusDescription"
    [isManualSettlementDate]="model.isManualSettlementDate"
    [settlementDate]="model.settlementDate"
    [administratorAnnotation]="model.administratorAnnotation"
    (tempSettlementDate)="setTempSettlementDate($event)"
    (tempAdministratorAnnotation)="setTempAdministratorAnnotation($event)"
  ></app-fiduci-proof>

  <app-annotation #annotation [annotation]="model.annotations"></app-annotation>

  <app-attachment
    #attachment
    [ticketId]="model.id"
    [canEdit]="canEdit()"
    [statusDescription]="model.statusDescription"
    [canChangeStatus]="canChangeStatus()"
    (tempTicketId)="setTempId($event)"
  ></app-attachment>

  <mat-expansion-panel *ngIf="showTransferStatus()" hideToggle>
    <mat-expansion-panel-header>
      <mat-panel-title> Dados da Transferência </mat-panel-title>
      <mat-panel-description> (Clique para expandir...) </mat-panel-description>
    </mat-expansion-panel-header>
    <div style="padding: 1rem">
      <app-transfer-status
        #transferstatus
        [ticketId]="model.id"
      ></app-transfer-status>
    </div>
  </mat-expansion-panel>
  <br />

  <div class="actions">
    <input
      type="button"
      value="Salvar"
      class="btn btn-primary me-2"
      appDebounceClick
      (debounceClick)="submit()"
      [debounceTime]="200"
      data-cy="submit"
      *ngIf="canEdit() || canEditSettlementDate()"
    />
    <input
      type="button"
      value="Encaminhar"
      class="btn btn-primary me-2"
      [disabled]="!canEdit()"
      appDebounceClick
      (debounceClick)="forward()"
      [debounceTime]="200"
      data-cy="forward"
      *ngIf="canEdit()"
    />
    <input
      type="button"
      value="Cancelar"
      class="btn btn-danger me-2"
      [disabled]="!canCancel()"
      appDebounceClick
      (debounceClick)="cancel()"
      [debounceTime]="200"
      data-cy="cancel"
      *ngIf="canEdit()"
    />
  </div>

  <div class="actions" *ngIf="canChangeStatus()">
    <input
      type="button"
      value="Aprovar"
      class="btn btn-success me-2"
      appDebounceClick
      (debounceClick)="approve()"
      [debounceTime]="200"
      data-cy="approve"
      [disabled]="disableActionButtons()"
    />
    <input
      type="button"
      value="Reprovar"
      class="btn btn-danger me-2"
      appDebounceClick
      (debounceClick)="reject()"
      [debounceTime]="200"
      data-cy="reject"
      [disabled]="disableActionButtons()"
    />
    <input
      *ngIf="enableCancelTransactionButton()"
      type="button"
      value="Cancelar Agendamento e Boleta"
      class="btn btn-warning me-2"
      appDebounceClick
      (debounceClick)="reject()"
      [debounceTime]="200"
      data-cy="reject"
    />
  </div>

  <div class="actions" *ngIf="canDuplicate()">
    <input
      type="button"
      value="Duplicar"
      class="btn btn-primary me-2"
      [disabled]="!model.id"
      appDebounceClick
      (debounceClick)="duplicate()"
      [debounceTime]="200"
      data-cy="duplicate"
    />
  </div>
</form>

<app-workflow-history
  [ticketId]="model.id"
  [refresh]="dataChanged"
></app-workflow-history>
